import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './authentication/components/login/login.component';
import { ErrorsPageComponent } from './base/components/errors-page/errors-page.component';
import { HomeComponent } from './base/components/home/home.component';
import { LandingPageComponent } from './base/components/landing-page/landing-page.component';
import { PageNotFoundComponent } from './base/components/page-not-found/page-not-found.component';
import { AuthenticatedGuard } from './shared/guards/authenticated/authenticated.guard';
import { AuthenticationKeycloakGuard } from './shared/guards/authentication-keycloak/authentication-keycloak.guard';
import { OperatorGuard } from './shared/guards/operator/operator.guard';
import { UnauthenticatedGuard } from './shared/guards/unauthenticated/unauthenticated.guard';
// import { RecoverPasswordComponent } from './authentication/components/recover-password/recover-password.component';
// import { SetPasswordComponent } from './authentication/components/set-password/set-password.component';
// import { TokenResolver } from './authentication/resolvers/token-resolver/token-resolver.service';

const routes: Routes = [
  {
    path: 'products',
    loadChildren: () => import('./product/product.module').then(m => m.ProductModule),
    //data: {roles: ['SuperAdmin']},
    canLoad: [AuthenticationKeycloakGuard],
  },
  {
     path: 'bundles',
     loadChildren: () => import('./bundle/bundle.module').then(m => m.BundleModule),
     canLoad: [AuthenticationKeycloakGuard],
  },
  {
    path: 'packages',
    loadChildren: () => import('./package/package.module').then(m => m.PackageModule),
    canLoad: [AuthenticationKeycloakGuard],
  },
  {
    path: 'partners',
    loadChildren: () => import('./partner/partner.module').then(m => m.PartnerModule),
    canLoad: [AuthenticationKeycloakGuard],
  }, 
  {
    path: 'reporting',
    loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule),
    canLoad: [AuthenticationKeycloakGuard],
  },
  {
    path: 'massive-configurations',
    loadChildren: () => import('./massive-configurations/massive-configurations.module').then(m => m.MassiveConfigurationsModule),
    canLoad: [AuthenticationKeycloakGuard],
  },
  {
    path: 'vouchers',
    loadChildren: () => import('./vouchers/vouchers.module').then(m => m.VouchersModule),
    canLoad: [AuthenticationKeycloakGuard],
  },
  {
    path: 'internal-server-error',
    component: ErrorsPageComponent,
    canActivate: [AuthenticationKeycloakGuard],
  },
  {
    path: 'bad-request',
    component: ErrorsPageComponent,
    canActivate: [AuthenticationKeycloakGuard],
  },
  {
    path: 'request-time-out',
    component: ErrorsPageComponent,
    canActivate: [AuthenticationKeycloakGuard],
  },
  {
    path: 'unauthorized',
    component: ErrorsPageComponent,
    canActivate: [AuthenticationKeycloakGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthenticationKeycloakGuard],
  },
  {
    path: '',
    component: LandingPageComponent,
    //canActivate: [UnauthenticatedGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'not-found',
  },
  {
    path: 'not-found',
    component: PageNotFoundComponent,
  },
  /*{
    path: 'analytics',
    loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule),
    canLoad: [AuthenticationKeycloakGuard],
  },*/
  /**
   * Eager Loaded
   */
  //{ path: 'login', component: LoginComponent, canActivate: [UnauthenticatedGuard] },
  // {
  //   path: 'setPassword',
  //   component: SetPasswordComponent,
  //   canActivate: [UnauthenticatedGuard],
  //   resolve: { tokenDetails: TokenResolver },
  // },
  // {
  //   path: 'recover-password',
  //   component: RecoverPasswordComponent,
  //   canActivate: [UnauthenticatedGuard],
  // },
  // {
  //   path: 'register',
  //   loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule),
  //   canLoad: [UnauthenticatedGuard],
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
